import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import Icon from 'components/icon/icon'

import Onboarder from 'components/onboarder/onboarder'

class SidebarItem extends Component {
	handleClick = e => {
		setTimeout(() => {
			this.forceUpdate()
		}, 10)
	}

	render() {
		const {
			link,
			icon,
			title,
			isNewTab
		} = this.props

		const inner = (
			<React.Fragment>
				<Icon name={icon} />
				<em className="sidebar-item-label">
					{title}
				</em>
			</React.Fragment>
		)

		return (
			<li>
				{title == 'People' ?
					<Onboarder type='OPENED_PEOPLE_TAB' direction="left" />
					: null}
				{title == 'Projects' ?
					<Onboarder type='OPENED_OTHER_PROJECT' direction="left" />
					: null}
				{isNewTab ?
					<a 
						href={link}
						target="_blank"
					>
						{inner}
					</a>
					:
					<NavLink
						to={link}
						activeClassName="selected"
						onClick={this.handleClick}
					>
						{inner}
					</NavLink>
				}
			</li>
		)
	}

}
export default SidebarItem;